import { useDrawer } from "../../stores/useDrawer"
import React, { useEffect, useState } from "react"
import {motion} from 'framer-motion'
import MessengerSidebar from "../chat/messsenger/sidebar";
import NeonSidebar from "../chat/neon/sidebar";
import TeamSidebar from "../chat/team/sidebar";
import SupportSidebar from "../chat/support/sidebar";
import { GroupDetail } from "../shared/details/groups";
import { RoomDetail } from "../shared/details/room";
import { MembersDetail } from "../shared/details/members";
import { FiX } from "react-icons/fi";

export const Drawers = ({}) => {
    const {status, type, values, styles, 
        headed, toggle} = useDrawer(state=>state)
    
    useEffect(()=>{},[type])

    const drawers = () => {
        switch (type) {
            case 'messenger-menu':
                return <MessengerSidebar values={values} mobile />;
            case 'neon-menu':
                return <NeonSidebar values={values} mobile />;
            case 'team-menu':
                return <TeamSidebar values={values} mobile />;
            case 'support-menu':
                return <SupportSidebar values={values} mobile />;
            break;
            case 'neon-detail':
                return <RoomDetail values={values} mobile />;
            break;
            case 'team-detail':
                return <MembersDetail values={values} mobile />;
            break;
            case 'messenger-detail':
                return <GroupDetail values={values} mobile />;
            break;
            case 'support-detail':
                return <GroupDetail values={values} mobile />;
            break;
            default:
            break;
        }
    }


    return  status ? (
        <React.Fragment>
        <div className="">

        <div  
        onClick={toggle}
         class="absolute right-4 top-4 bg-red-500/70 hover:bg-red-400 z-[101] p-3 text-white rounded-full flex items-center justify-center cursor-pointer">
            <FiX size={23} />
        </div>
        
            <div class="absolute left-0 top-0 bottom-0 h-full w-full flex">
                <motion.div
                   animate={{x: [-255,0]  }}
                   transition={{ ease: "easeIn" }}
                   className="z-[100]"
                >
                    <div  class="
                    w-fit overflow-hidden h-auto rounded-md relative
                    block items-center justify-center z-[100]">
                    {drawers()}
                    </div>
                   
                 </motion.div>
            </div>
        <div 
        onClick={toggle}
        class="bg-white/10 dark:bg-black/10 backdrop-blur-md absolute left-0 right-0 bottom-0 top-0 z-[99]"></div>
        </div>
        </React.Fragment>
    ) : <></>
  }


